
















































/* eslint-disable @typescript-eslint/camelcase */

import { Component, Prop } from "vue-property-decorator";
import {
  getCartePlace,
  getCartePlace_getCartePlace
} from "../graphql/types/getCartePlace";

import AppTextModule from "../store/modules/appTextModule";
import Citation from "../components/Citation.vue";
import QueryPlace from "../graphql/queryPlace";
import Util from "../util";
import ViewBase from "../views/ViewBase";
import { getCartePlaceVariables } from "../graphql/types/getCartePlace";
import { getModule } from "vuex-module-decorators";

const appTextStore = getModule(AppTextModule);

@Component({
  apollo: {
    place: {
      query: QueryPlace.getCartePlace,
      variables(): getCartePlaceVariables {
        return {
          language: `${this.language}`,
          id: parseInt(this.id)
        };
      },
      update(data: getCartePlace) {
        // The returned value will update
        // the vue property 'place'
        const result = data?.getCartePlace;
        return result;
      },
      fetchPolicy: "cache-and-network",
      error(error) {
        this.onError(error);
      }
    }
  },
  components: { Citation }
})
export default class Place extends ViewBase {
  @Prop() private id?: string;

  private place?: getCartePlace_getCartePlace;

  protected get title() {
    return this.place?.name ? this.place.name : "";
  }

  private get manufactures() {
    const result = Util.removeNull(this.place?.requiredBy);

    // sort manufactures alphabetically
    result.sort((a, b) => {
      if (a?.name && b?.name) {
        return a.name.localeCompare(b.name);
      } else {
        return -1;
      }
    });

    return result;
  }

  private get hasManufactures() {
    return this.manufactures.length > 0;
  }

  private get citations() {
    return Util.removeNull(this.place?.requiredByCitation);
  }

  private get hasCitations() {
    return this.citations.length > 0;
  }

  private get hasInfo() {
    return this.place?.information != "";
  }

  private get textManufactures() {
    return appTextStore.appTextByKey("text.manufactures");
  }

  private get textCitations() {
    return appTextStore.appTextByKey("text.citations");
  }

  private get textInfo() {
    return appTextStore.appTextByKey("text.info");
  }
}
